<template>
  <div class="loader">
    <i class="fa-solid fa-circle-notch" :style="style" />
  </div>
</template>

<script setup lang="ts">
import type { CSSProperties, PropType } from "vue";

import { computed } from "vue";

const props = defineProps({
  size: {
    type: String as PropType<string | null>,
    default: null,
  },
});

const style = computed<CSSProperties>(() => ({
  width: props.size || undefined,
  height: props.size || undefined,
}));
</script>

<style scoped lang="postcss">
.loader {
  @apply flex h-full w-full items-center justify-center border-none text-2xl;
}
</style>
